import template from './price.jade';

import { initializeSegmentInputTooltips } from '../../../utils/segment-input-tooltips';

/*
. Для собственника:

a) добавить на форму подачи (продажа-квартиры) чекбокс "Ипотека возможна",
предвыбранный по умолчанию. С возможностью выключить его. При этом:

Для новых объявлений чекбокс должен быть в предвыбранном состоянии.

При редактировании, восстановлении объявления из архива, восстановлении
неактивного и отклоненного модератором объявления, которое было создано до релиза,
чекбокс также должен быть, но он должен быть в непредвыбранном состоянии.

При редактировании, восстановлении объявления из архива, восстановлении неактивного и
отклоненного модератором объявления, которое было создано после релиза, чекбокс должен
соответствовать тому состоянию, которое было выбрано при создании.

b) для объявлений по продаже других типов жилой недвижимости (кроме типа объекта "Квартира", "Участок"):

при создании нового объявления чекбокс "Ипотека возможна" должен быть предвыбран
при редактировании, восстановлении объявления из архива, восстановлении неактивного и
отклоненного модератором объявления чекбокс должен соответствовать тому состоянию, которое было выбрано при создании.


2. Для риэлтора

Для нового объявления сделать чекбокс "Ипотека возможна" на форме подачи (продажа жилой недвижимости,
  кроме типа объекта "Участок") по умолчанию предвыбранным, с возможностью выключить его.
при редактировании, восстановлении объявления из архива, восстановлении неактивного и
отклоненного модератором объявления состояние чекбокса должно соответствовать тому состоянию,
которое было выбрано при создании.

Для "Активного черновика" чекбокс должен сохранять свое состояние.
*/

import { isNewOffer } from '../../../services/ad-state.service';

export default angular.module('cian.addForm.price', []).directive('cianAfPriceAndDealTermsPrice', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller($scope, adTooltipsService, analyticsService, deviceService, popupService) {
    'ngInject';
    this.isMobile = deviceService.isMobile;
    this.modalHintTitle = 'Цена';
    this.tooltipText = '';
    const allowedCategories = [
      'flatSale',
      'newBuildingFlatSale',
      'roomSale',
      'flatShareSale',
      'houseSale',
      'cottageSale',
      'townhouseSale',
      'houseShareSale',
    ];
    this.isMortgageCheckboxEnabled = () => {
      return allowedCategories.includes(this.ad.category);
    };

    if (!this.ad.bargainTerms) {
      this.ad['bargainTerms'] = {};
    }

    if (
      allowedCategories.includes(this.ad.category) &&
      isNewOffer &&
      this.ad.bargainTerms.mortgageAllowed === undefined
    ) {
      this.ad.bargainTerms.mortgageAllowed = true;
    }

    initializeSegmentInputTooltips({
      controller: this,
      $scope,
      adTooltipsService,
      adAnalyticsCategory: analyticsService.adAnalyticsCategory,
      tooltipsKey: 'bargainTerms.price',
      trackingLabel: 'price-hint',
      popupService,
      isMobile: this.isMobile,
    });
  },
  controllerAs: 'price',
  template,
})).name;
